import { render, staticRenderFns } from "./modal-confirmar-escoger.vue?vue&type=template&id=1bef7d59&scoped=true"
import script from "./modal-confirmar-escoger.vue?vue&type=script&lang=js"
export * from "./modal-confirmar-escoger.vue?vue&type=script&lang=js"
import style0 from "./modal-confirmar-escoger.vue?vue&type=style&index=0&id=1bef7d59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef7d59",
  null
  
)

export default component.exports